import * as React from 'react';
import API from "../../Services/API";
import Navbar from "../../Layouts/Navbar";
import {toast} from "react-toastify";
import Toast from "../../Components/Toast";
import Loading from "../../Layouts/Loading";
import Header from "../../Layouts/Header";
import * as shamsi from 'shamsi-date-converter';

import {
    Chart as ChartJS,
    CategoryScale,
    LinearScale,
    PointElement,
    LineElement,
    Title,
    Tooltip,
    Legend,
} from 'chart.js';
import { Line } from 'react-chartjs-2';
import {GiFactory} from "react-icons/gi";
import {FaCarBattery} from "react-icons/fa";
import {PiUsersThreeFill} from "react-icons/pi";


ChartJS.register(
    CategoryScale,
    LinearScale,
    PointElement,
    LineElement,
    Title,
    Tooltip,
    Legend
);


let label = [];
let labelAmp = [];
let count = [];
let countAmp = [];
let labelR = [];
let countR = [];

export default function Home() {

    const [isLoaded, setIsLoaded] = React.useState(false);
    const [data, setData] = React.useState(false);

    React.useEffect(() => {
        API.getDashboard()
            .then((response) => {
                setData(response.data);
                setIsLoaded(true);
                label = [];
                count = [];
                labelR = [];
                countR = [];
                response.data.saleDay.forEach(element => {

                    label.push(shamsi.gregorianToJalali(element.date).join('/'));
                    count.push(element.count);
                });
                response.data.saleAmp.forEach(element => {

                    labelAmp.push(shamsi.gregorianToJalali(element.date).join('/'));
                    countAmp.push(element.count);
                });

                response.data.returnDay.forEach(element => {

                    labelR.push(shamsi.gregorianToJalali(element.date).join('/'));
                    countR.push(element.count);
                });


            })
            .catch((error) => {

                if(error.response) {
                    toast.error(error.response.data.message);
                }
                else {
                    toast.error(error.message);
                }
            });
        setTimeout(() => {
            window.scrollTo({top: 0, behavior: 'smooth'});
        }, 400)
    }, []);

    return (
        <React.Fragment>
            <Toast />
            {
                !isLoaded && <Loading />
            }
            <Header hasBack={false} title='NGKH'  />


            <section className='container-fluid my-3 py-5 rtl'>
                <div className="row">
                    <div className="col-6 mt-3">
                        <div className="card text-center">
                            <div className="card-body">
                                <GiFactory  className='text-big-5 text-warning' />
                                <h5 className="card-title fw-bold my-3">
                                    تعداد کل باتری های داخل کارخانه
                                    <br/>
                                    <span className='text-small-1 text-muted'>(خودرویی)</span>
                                </h5>
                                <div className='fw-bold'>
                                    {data.factoryProductsCount}
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="col-6 mt-3">
                        <div className="card text-center">
                            <div className="card-body">
                                <GiFactory  className='text-big-5 text-warning' />
                                <h5 className="card-title fw-bold my-3">
                                    تعداد کل باتری های داخل کارخانه
                                    <br/>
                                    <span className='text-small-1 text-muted'>(VRLA )</span>
                                </h5>
                                <div className='fw-bold'>
                                    {data.factoryProductsCountVRLA}
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="col-6 mt-3">
                        <div className="card text-center">
                            <div className="card-body">
                                <FaCarBattery   className='text-big-5 text-info' />
                                <h5 className="card-title fw-bold my-3">
                                    تعداد کل باتری های دارای گارانتی

                                </h5>
                                <div className='fw-bold'>
                                    {data.activeBatteries}
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="col-6 mt-3">
                        <div className="card text-center">
                            <div className="card-body">
                                <PiUsersThreeFill   className='text-big-5 text-success' />
                                <h5 className="card-title fw-bold my-3">
                                    تعداد کل مشتری های ثبت  شده
                                    <br/>

                                </h5>
                                <div className='fw-bold'>
                                    {data.userCount}
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="col-12 mt-3">

                        <div className="card text-center">
                            <div className="card-body">
                                <h5 className="card-title fw-bold mb-3">
                                    فروش تعدادی در 10 روز گذشته (در سراسر کشور)
                                </h5>
                                <Line
                                    datasetIdKey='id'
                                    data={{
                                        labels: label,
                                        datasets: [
                                            {
                                                id: 1,
                                                label: 'تعداد',
                                                data: count,
                                                backgroundColor: 'rgba(1,70,1,0.52)',
                                                borderColor: 'rgba(3,150,3,0.4)',
                                            },

                                        ],
                                    }}
                                />
                            </div>
                        </div>

                    </div>
                    <div className="col-12 mt-3">

                        <div className="card text-center">
                            <div className="card-body">
                                <h5 className="card-title fw-bold mb-3">
                                    فروش آمپری در 10 روز گذشته (در سراسر کشور)
                                </h5>
                                <Line
                                    datasetIdKey='id'
                                    data={{
                                        labels: labelAmp,
                                        datasets: [
                                            {
                                                id: 1,
                                                label: 'آمپر',
                                                data: countAmp,
                                                backgroundColor: 'rgba(1,70,1,0.52)',
                                                borderColor: 'rgba(3,150,3,0.4)',
                                            },

                                        ],
                                    }}
                                />
                            </div>
                        </div>

                    </div>
                    <div className="col-12 mt-3">

                        <div className="card text-center ">
                            <div className="card-body">
                                <h5 className="card-title fw-bold mb-3">
                                    تعداد مرجوعی در 10 روز گذشته   (در سراسر کشور)
                                </h5>
                                <Line
                                    datasetIdKey='id'
                                    data={{
                                        labels: labelR,
                                        datasets: [
                                            {
                                                id: 1,
                                                label: 'تعداد',
                                                data: countR,
                                                backgroundColor: 'rgba(70,1,25,0.52)',
                                                borderColor: 'rgba(150,3,69,0.4)',
                                            },

                                        ],
                                    }}
                                />
                            </div>
                        </div>

                    </div>

                </div>
            </section>
            <Navbar />
        </React.Fragment>
    );
};
